import * as core from '../../../../../../../core'

import { query } from './save-proposal-personnel-row.query'

export const RESOURCE = {
  payload: {
    alias: 'save.proposal.personnel.row',
    description:
      'Creates or updates a proposal-personnel row from the proposal-personnel row edit modal',
    name: 'Save Proposal Personnel Row',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
